module.exports = __webpack_public_path__ + "static/media/about_me.7f4eecbe.png";